/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HomerunConnectionConfigFromJSON, HomerunConnectionConfigToJSON, } from './HomerunConnectionConfig.js';
/**
 * Check if a given object implements the UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig interface.
 */
export function instanceOfUpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig(value) {
    if (!('defaultMessageId' in value) || value['defaultMessageId'] === undefined)
        return false;
    if (!('senderEmployerId' in value) || value['senderEmployerId'] === undefined)
        return false;
    return true;
}
export function UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfigFromJSON(json) {
    return UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfigFromJSONTyped(json, false);
}
export function UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'defaultMessageId': json['defaultMessageId'],
        'senderEmployerId': json['senderEmployerId'],
        'config': json['config'] == null ? undefined : HomerunConnectionConfigFromJSON(json['config']),
    };
}
export function UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfigToJSON(json) {
    return UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfigToJSONTyped(json, false);
}
export function UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'defaultMessageId': value['defaultMessageId'],
        'senderEmployerId': value['senderEmployerId'],
        'config': HomerunConnectionConfigToJSON(value['config']),
    };
}
